/* eslint-disable */
import React, { useEffect, useState } from "react";
import "./Admin.css";
import { Dropdown } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import { useUserAuth } from "../../context/UserAuthContext";
import ChatNot from "../../components/Chat/ChatNot";
import AddDoctor from "../../AdminPages/AddDoctor/AddDoctor"; // Import AddDoctor Component
import AddTechnician from "../../AdminPages/AddTechnician/AddTechnician";
import { getDatabase, ref, get, remove, onValue, off } from "firebase/database";
// import CryptoJS from "crypto-js";
import AssignDoctor from "../../AdminPages/AssignDoctor/AssignDoctor";
//import UpdatePageDoc from "../../AdminPages/UpdatePageDoc/UpdatePageDoc"; // Import Update Component
import {  Tooltip, Legend } from 'recharts';
import { PieChart, Pie, Cell,   } from 'recharts';
import BillingDetailsAdmin from "../../pages/Billing/BillingDetailsAdmin/BillingDetailsAdmin";
import AdminBillingUsage from '../../pages/AdminBillingUsage/AdminBillingUsage'; 
// import AdminPaymentReceipt from '../../pages/AdminPaymentReceipt/AdminPaymentReceipt'; 
import AddPatient from "../../AdminPages/AddPatient/AddPatient";
// import SessionTimeout from "../../pages/SessionTimeout/SessionTimeout";s
import Wallet from "../../pages/Wallet/Wallet";
import Dashboard from "../../AdminPages/Dashboard/Dashboard";


function Admin() {
  const { logOut } = useUserAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [adminName1, setAdminName1] = useState("");
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  
  // Initialize activeSection based on URL parameter to prevent flicker
  const getInitialSection = () => {
    const params = new URLSearchParams(location.search);
    const section = params.get('section');
    const validSections = ['AssignDoctor', 'Patients', 'Doctors', 'Technicians', 'Billing', 'Wallet'];
    return (section && validSections.includes(section)) ? section : "AssignDoctor";
  };
  
  const [activeSection, setActiveSection] = useState(getInitialSection);
  const [costingType, setCostingType] = useState("");
  const [walletBalance, setWalletBalance] = useState(0);
  const [activeSubSection, setActiveSubSection] = useState("Enrollment");
  const [dashboardData, setDashboardData] = useState({
    doctors: 0,
    technicians: 0,
    patients: 0,
  });
  const [doctors, setDoctors] = useState({});
  // const [showBillingNotAvailable, ] = useState(false);
  const [technicians, setTechnicians] = useState({});
  const [currency, setCurrency] = useState('INR'); // Default to INR

  // Check URL parameters to set active section
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const section = params.get('section');
    const validSections = ['AssignDoctor', 'Patients', 'Doctors', 'Technicians', 'Billing', 'Wallet'];
    if (section && validSections.includes(section)) {
      setActiveSection(section);
    }
  }, [location.search]);

  useEffect(() => {
    const savedSection = localStorage.getItem("activeSection");
    const savedSubSection = localStorage.getItem("activeSubSection");
    const savedSidebarState = localStorage.getItem("isSidebarOpen");
  
    // Only use saved section if no URL parameter is present
    const params = new URLSearchParams(location.search);
    const urlSection = params.get('section');
    
    if (!urlSection && savedSection) {
      setActiveSection(savedSection);
      setActiveSubSection(savedSubSection || "");
    }
  
    if (savedSidebarState !== null) {
      setSidebarOpen(savedSidebarState === "true");
    }
  }, []);
  

 // NEW: Fetch wallet balance if adminName is available
 useEffect(() => {
  if (adminName1) {
    const db = getDatabase();
    const walletBalanceRef = ref(db, `superadmin/admins/${adminName1}/Wallet/Wallet_Balance`);
    const unsubscribe = onValue(
      walletBalanceRef,
      (snapshot) => {
        if (snapshot.exists()) {
          setWalletBalance(snapshot.val());
        }
      },
      (error) => {
        console.error("Error fetching wallet balance:", error);
      }
    );
    return () => unsubscribe();
  }
}, [adminName1]);

  
useEffect(() => {
  const adminName = localStorage.getItem("adminName");
  setAdminName1(adminName);

  if (adminName) {
    const db = getDatabase();
    const doctorRef = ref(db, `superadmin/admins/${adminName}/doctors`);
    const technicianRef = ref(db, `superadmin/admins/${adminName}/technicians`);

    // Real-time listener for Doctors
    const unsubscribeDoctors = onValue(doctorRef, (doctorSnapshot) => {
      if (doctorSnapshot.exists()) {
        const doctorData = doctorSnapshot.val();
        setDoctors(doctorData);
        setDashboardData((prev) => ({
          ...prev,
          doctors: Object.keys(doctorData).length,
        }));
      } else {
        setDoctors({});
        setDashboardData((prev) => ({ ...prev, doctors: 0 }));
      }
    });

    // Real-time listener for Technicians
    const unsubscribeTechnicians = onValue(technicianRef, (technicianSnapshot) => {
      if (technicianSnapshot.exists()) {
        const technicianData = technicianSnapshot.val();
        setTechnicians(technicianData);
        setDashboardData((prev) => ({
          ...prev,
          technicians: Object.keys(technicianData).length,
        }));
      } else {
        setTechnicians({});
        setDashboardData((prev) => ({ ...prev, technicians: 0 }));
      }
    });

    // Cleanup function to unsubscribe from listeners
    return () => {
      unsubscribeDoctors();
      unsubscribeTechnicians();
    };
  }
}, []); // Run once on component mount

const handleUpdateTech = (technicianId) => {
  navigate(`/Admin/UpdatePageTech/${technicianId}`);
};


  const [modalityCounts, setModalityCounts] = useState({
    CTUploads: 0,
    XrayUploads: 0,
    MriUploads: 0,
    TotalUpload: 0
  });
  useEffect(() => {
    const db = getDatabase();
    const adminRef = ref(db, 'superadmin/admins/Deepika Dave');
  
    get(adminRef).then((snapshot) => {
      if (snapshot.exists()) {
        const data = snapshot.val();
        setModalityCounts({
          CTUploads: data.CTUploads || 0,
          XrayUploads: data.XrayUploads || 0,
          MriUploads: data.MriUploads || 0,
          TotalUpload: data.TotalUpload || 0
        });
        // Update other dashboard data if needed
        setDashboardData(prev => ({
          ...prev,
          totalViews: data.totalViews || 0
        }));
      } else {
        setModalityCounts({
          CTUploads: 0,
          XrayUploads: 0,
          MriUploads: 0,
          TotalUpload: 0
        });
      }
    }).catch(error => {
      console.error("Error fetching data: ", error);
    });
  }, []);  // Dependency array left empty to run only on component mount
    
  // const modalityData = [
  //   { name: 'CT Uploads', value: modalityCounts.CTUploads },
  //   { name: 'X-ray Uploads', value: modalityCounts.XrayUploads },
  //   { name: 'MRI Uploads', value: modalityCounts.MriUploads }
  // ];
  
const modalityData = [
  { name: 'CT Uploads', value: modalityCounts.CTUploads },
  { name: 'X-ray Uploads', value: modalityCounts.XrayUploads },
  { name: 'MRI Uploads', value: modalityCounts.MriUploads }
].filter(item => item.value > 0);  // Filter out entries with value 0


  const colors = ['#0088FE', '#00C49F', '#FFBB28'];  // Colors for pie chart sectors
// Delete Technician
const onDeleteRecord = async (type, id) => {
  if (window.confirm("Are you sure you want to delete this record?")) {
    const adminName = localStorage.getItem("adminName");
    const db = getDatabase();
    const recordRef = ref(db, `superadmin/admins/${adminName}/${type}/${id}`);
    await remove(recordRef);

    // Update state based on type
    if (type === "technicians") {
      const updatedTechnicians = { ...technicians };
      delete updatedTechnicians[id];
      setTechnicians(updatedTechnicians);
    }
  }
};

const renderTechnicianRows = (technicians) => {
  return Object.keys(technicians).map((key) => (
    <tr key={key}>
      <td>{technicians[key].Name}</td> {/* Name column */}
      <td>{technicians[key].Email}</td> {/* Email column */}

<td className="action-cell-custom">
  <div className="action-btn-container">
    <button
      className="update-btn-custom"
      onClick={() => handleUpdateTech(key)}
    >
      Update
    </button>
    <button
  className="delete-btn-custom"
  onClick={() => onDeleteRecord("technicians", key)}
>
  Delete
</button>
  </div>
</td>
    </tr>
  ));
};

  
// Dashboard code - using new comprehensive Dashboard component

const renderDashboard = () => {
  return <Dashboard />;
};


// const handleLogout = async () => {
//     try {
//       await logOut();
//       navigate("/");
//     } catch (error) {
//       console.error(error.message);
//     }
//   };
// coded added 20feb issue for same page login after logout
const handleLogout = async () => {
  try {
    await logOut();
    
    // Clear stored session data
    localStorage.removeItem("activeSection");
    localStorage.removeItem("activeSubSection");
    localStorage.removeItem("isSidebarOpen");

    // Reset scroll position
    window.scrollTo(0, 0);

    // Redirect to login
    navigate("/", { replace: true });

  } catch (error) {
    console.error("Logout Error:", error);
  }
};

  // Delete Doctor
  const handleDeleteDoctor = async (doctorId) => {
    if (window.confirm("Are you sure you want to delete this doctor?")) {
      const db = getDatabase();
      const doctorRef = ref(
        db,
        `superadmin/admins/${adminName1}/doctors/${doctorId}`
      );
      await remove(doctorRef);
      const updatedDoctors = { ...doctors };
      delete updatedDoctors[doctorId];
      setDoctors(updatedDoctors);
      setDashboardData((prev) => ({
        ...prev,
        doctors: Object.keys(updatedDoctors).length,
      }));
    }
  };
  useEffect(() => {
    const fetchCostingDetails = async () => {
      const adminName = localStorage.getItem("adminName");
      const db = getDatabase();
      const snapshot = await get(ref(db, `superadmin/admins/${adminName}`));
      const adminData = snapshot.val();
      if (adminData.CostingType) {
        setCostingType(adminData.CostingType);
      } else if (adminData.costing) {
        if (adminData.costing.CPU) {
          setCostingType("Cost Per Upload");
        } else if (adminData.costing.CPV) {
          setCostingType("Cost Per View");
        } else if (adminData.costing.CPU && adminData.costing.CPV) {
          setCostingType("Cost Per Upload + View");
        } else {
          setCostingType("Not Set");
        }
      } else {
        setCostingType("Not Set");
      }
      setAdminName1(adminName);
    };

    fetchCostingDetails();
  }, []);

  useEffect(() => {
    const db = getDatabase();
    if (adminName1) {  // Ensure adminName1 is not empty
        // Correct the path to where the modality data is stored
        const costingRef = ref(db, `superadmin/admins/${adminName1}/costing`);

        get(costingRef).then((snapshot) => {
            if (snapshot.exists()) {
                const data = snapshot.val();
                // Update the state to reflect the proper data paths
                setModalityCounts({
                    CTUploads: data.CTUploads || 0,
                    MriUploads: data.MriUploads || 0,
                    XrayUploads: data.XrayUploads || 0,
                    TotalUpload: data.TotalUpload || 0
                });
                // Setting totalViews assuming it's stored at the same level
                setDashboardData(prev => ({
                    ...prev,
                    totalViews: data.totalViews || 0,
                    uploadEvents: data.Upload_Events || { CT: 0, Xray: 0, MRI: 0 }
                }));
            } else {
                console.log("No costing data available");
                setModalityCounts({
                    CTUploads: 0,
                    MriUploads: 0,
                    XrayUploads: 0,
                    TotalUpload: 0
                });
                setDashboardData(prev => ({
                    ...prev,
                    totalViews: 0,
                    uploadEvents: { CT: 0, Xray: 0, MRI: 0 }
                }));
            }
        }).catch(error => {
            console.error("Failed to fetch costing data", error);
        });
    }
}, [adminName1]); // Re-run this effect if adminName1 changes

  // Fetch admin currency from Firebase
  useEffect(() => {
    if (adminName1) {
      const db = getDatabase();
      const currencyRef = ref(db, `superadmin/admins/${adminName1}/Currency`);
      get(currencyRef).then((snapshot) => {
        if (snapshot.exists()) {
          setCurrency(snapshot.val());
        } else {
          setCurrency('INR'); // fallback to INR if not set
        }
      }).catch((error) => {
        console.error('Error fetching currency:', error);
        setCurrency('INR');
      });
    }
  }, [adminName1]);

  // Navigate to Update Page
  const handleUpdateDoctor = (doctorId) => {
    navigate(`/Admin/UpdateDoctor/${doctorId}`);
  };
  const renderContent = () => {
    
    switch (activeSection) {
      case "Doctors":
        if (activeSubSection === "Enrollment") {
          return (
            <div>
              <div className="back-header">
                
              </div>
              <AddDoctor />
            </div>
          );
        } else if (activeSubSection === "ViewList") {
          return (
            <div>
              <div className="header">
                <h2
                style={{
                  position: "sticky",
                  top: "10px",
                  left: "0",  // Lock it horizontally
                  zIndex: "1000",
                  backgroundColor: "inherit",
                  padding: "10px 0"
                }}>Doctors List</h2>
                {/* Add Doctor Button */}
                <button
                  className="add-doctor-btn"
                  onClick={() => setActiveSubSection("Enrollment")}>
                  + Add Doctor
                </button>
              </div>
              <table className="doctors-table-admin">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Name</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {Object.keys(doctors).length > 0 ? (
                    Object.keys(doctors).map((key) => (
                      <tr key={key}>
                        <td>{doctors[key].ID}</td>
                        <td>{doctors[key].Name}</td>
                        <td>
                          <button
                          
                            className="btn btn-edit"
                            onClick={() => handleUpdateDoctor(key)}>
                            Update
                          </button>
                          <button
                            className="btn btn-delete delete-btn-custom"
                            onClick={() => handleDeleteDoctor(key)}>
                            Delete
                          </button>
                        </td>

                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="3">No doctors available.</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          );
        }
        break; // Ensure to break after each case
  
      case "Technicians":
        if (activeSubSection === "Enrollment") {
          return (
            <div>
              <div className="back-header">
                
              </div>
              <AddTechnician />
            </div>
          );
        } else if (activeSubSection === "ViewList") {
          return (
            <div>
              <div className="header">
                {/* <h2>Technicians List</h2> */}

                <h2 style={{
  position: "sticky",
  top: "10px",
  left: "0",  // Lock it horizontally
  zIndex: "1000",
  backgroundColor: "inherit",
  padding: "10px 0"
}}>
  Technicians List
</h2>

                {/* Add Technician Button */}
                <button
                  className="add-doctor-btn"
                  onClick={() => setActiveSubSection("Enrollment")}>
                  + Add Technician
                </button>
              </div>
              <table className="technicians-table-admin">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {Object.keys(technicians).length > 0 ? (
                    renderTechnicianRows(technicians)
                  ) : (
                    <tr>
                      <td colSpan="3">No technicians available.</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          );
        }
        break;
  
      case "Dashboard":
        return renderDashboard();

        case "Billing":
          return (
            <div className="billing-section">
              <BillingDetailsAdmin id={adminName1} />
            </div>
          );

    case "Usage":
      return (
          <div className="usage-section">
              <AdminBillingUsage id={adminName1} />
          </div>
      );
      // PaymentReceipt case - COMMENTED OUT
      /* case "PaymentReceipt":
      return (
        <div className="payment-receipt-section">
          <AdminPaymentReceipt id={adminName1} /> 
        </div>
      ); */
      case "PatientEnrollment":
        return (
          <div className="patient-enrollment-section">
            <AddPatient />
          </div>
        );
      
        case "Wallet":
        if (costingType === "Prepaid") {
          return (
            <div className="wallet-section">
              <Wallet adminId={adminName1} redirectRoute="/Admin" />
            </div>
          );
        } else {
          return (
            <div className="wallet-section">
              <p>Wallet is available only for admins with Prepaid costing type.</p>
            </div>
          );
        }
  
      default:
        return <AssignDoctor />;
    }
  };


  const toggleSidebar = () => {
    setSidebarOpen((prev) => {
      localStorage.setItem("isSidebarOpen", !prev); // Save sidebar state
      return !prev;
    });
  };
  
;


const handleMenuClick = (section, subSection = null) => {
  setActiveSection(section);
  setActiveSubSection(subSection || "");
  
  // Update URL with section parameter
  navigate(`/Admin?section=${section}`, { replace: true });

  localStorage.setItem("activeSection", section);
  localStorage.setItem("activeSubSection", subSection || "");

  //deepaaudit logs - Handle navigation to audit logs
  if (section === "ViewLogs") {
    navigate("/Admin/AuditLogs");
    return;
  }

  // PaymentReceipt section handling - COMMENTED OUT
  /* if (section === "PaymentReceipt") {
    setAdminName1(localStorage.getItem("adminName")); // Ensure adminName1 is set
  } */

  // Only close the sidebar if the viewport width is 768px or less (mobile view)
  if (window.innerWidth <= 768) {
    setSidebarOpen(false); // Close the sidebar for mobile
  }
};
    // Keep Sidebar Open on Desktop
    useEffect(() => {
      const handleResize = () => {
        if (window.innerWidth > 768) {
          setSidebarOpen(true);
        }
      };
  
      window.addEventListener("resize", handleResize);
      return () => {
        window.removeEventListener("resize", handleResize);
      };
    }, []);


    return (
      <div className="admin-container">
        {/* Top Panel */}
        <div className="top-panel">
          <button className="hamburger-btn" onClick={toggleSidebar}>
            {isSidebarOpen ? 'X' : '☰'}
          </button>
          <Dropdown className="ml-auto">
          <Dropdown.Toggle variant="secondary" id="dropdown-basic">
            {adminName1 || "Admin"}
            {costingType.toLowerCase() === "prepaid" && (
               ` (Balance: ${currency === 'USD' ? '$' : '₹'}${walletBalance})`
             )}
          </Dropdown.Toggle>
            <Dropdown.Menu className="logout-menu">
              <Dropdown.Item onClick={handleLogout}>Logout</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
    
        {/* Main area with sidebar and content */}
        <div className="main">
          {isSidebarOpen && (
            <div className="menubaradmin open">
              <ul>
                <li 
                  onClick={() => handleMenuClick("AssignDoctor")} 
                  className={activeSection === "AssignDoctor" ? "active-menu-item" : ""}
                >
                  <i className="fas fa-procedures"></i> Patients
                </li>
                <li 
                  onClick={() => handleMenuClick("Doctors", "ViewList")} 
                  className={activeSection === "Doctors" ? "active-menu-item" : ""}
                >
                  <i className="fas fa-user-md"></i> Doctors
                </li>
                <li 
                  onClick={() => handleMenuClick("Technicians", "ViewList")} 
                  className={activeSection === "Technicians" ? "active-menu-item" : ""}
                >
                  <i className="fas fa-hospital-user"></i> Technicians
                </li>
                <li 
                  onClick={() => handleMenuClick("Dashboard")} 
                  className={activeSection === "Dashboard" ? "active-menu-item" : ""}
                >
                  <i className="fas fa-chart-bar"></i> Dashboard
                </li>
                <li 
                  onClick={() => handleMenuClick("Billing")} 
                  className={activeSection === "Billing" ? "active-menu-item" : ""}
                >
                  <i className="fas fa-file-invoice"></i> Billing
                </li>
                {/* Only show Wallet option if costingType is Prepaid */}
              {costingType === "Prepaid" && (
                <li onClick={() => handleMenuClick("Wallet")}
                  className={activeSection === "Wallet" ? "active-menu-item" : ""}
                >
                  <i className="fas fa-wallet"></i> Wallet
                </li>
              )}
                <li 
                  onClick={() => handleMenuClick("Usage")} 
                  className={activeSection === "Usage" ? "active-menu-item" : ""}
                >
                  <i className="fas fa-chart-line"></i> Usage
                </li>
                {/* Receipt Option - COMMENTED OUT 
                <li 
                  onClick={() => handleMenuClick("PaymentReceipt")} 
                  className={activeSection === "PaymentReceipt" ? "active-menu-item" : ""}
                >
                  <i className="fas fa-receipt"></i> Receipt
                </li>
                */}
                {/* <li 
                  onClick={() => handleMenuClick("ViewLogs")} 
                  className={activeSection === "ViewLogs" ? "active-menu-item" : ""}
                >
                  <i className="fas fa-clipboard-list"></i> View Logs
                </li> */}
              </ul>
            </div>
          )}
    
          <div className={`content ${isSidebarOpen ? "" : "sidebar-closed"}`}>
            {renderContent()}
            <ChatNot />
          </div>
        </div>
      </div>
    );
    
}
export default Admin;
